import { useState } from 'react';
import { getMarketplace, INTEGRATION_CHANNEL } from '../../utils/marketplace';
import './MarketplaceBadge.css';

/**
 * Sipariş kanalı rozeti (pazaryeri logosu ya da dış POS etiketi).
 *
 * Kanal bilinmiyorsa hiçbir şey çizmez: "Bilinmiyor" etiketi satıra bilgi katmaz.
 * Görsel yüklenemezse (dosya eksik/engellendi) kanal adının kısa hâli yazıya düşer —
 * kırık görsel ikonu, adı hiç yazmamaktan daha kötüdür.
 *
 * @param code MarketplaceType değeri
 * @param integration Paket dış POS entegratöründen mi geldi (pazaryeri kodunu ezer)
 * @param size 'sm' liste satırı · 'md' detay paneli
 * @param withLabel Logonun yanında kanal adı da yazılsın mı
 */
const MarketplaceBadge = ({ code, integration = false, size = 'sm', withLabel = false }) => {
    const [imageFailed, setImageFailed] = useState(false);
    // Dış POS pazaryeri kodunu ezer: o paketin kodu zaten Unknown gelir, ama bir gün
    // dolarsa bile paketin kimliği kanaldır — hangi uygulamadan geldiği değil.
    const info = integration ? INTEGRATION_CHANNEL : getMarketplace(code);

    if (!info) return null;

    const showImage = info.logo && !imageFailed;

    return (
        <span
            className={`mp-badge mp-${size} ${withLabel ? 'mp-with-label' : ''}`}
            style={{ '--mp-color': info.color }}
            title={info.label}
        >
            {showImage ? (
                <img src={info.logo} alt={info.label} onError={() => setImageFailed(true)} />
            ) : (
                <span className="mp-fallback">{withLabel ? info.label : info.short}</span>
            )}
            {withLabel && showImage && <span className="mp-label">{info.label}</span>}
        </span>
    );
};

export default MarketplaceBadge;
